import { anatomyModule } from "./anatomy";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";

export const colonModules = [anatomyModule, histologyModule, physiologyModule];
